import React from 'react';

interface CallRecordingIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const CallRecordingIcon: React.FC<CallRecordingIconProps> = ({
  width = 20,
  height = 20,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.0003 10.4227C10.2304 10.4227 10.417 10.2362 10.417 10.0061C10.417 9.77596 10.2304 9.58941 10.0003 9.58941C9.77021 9.58941 9.58366 9.77596 9.58366 10.0061C9.58366 10.2362 9.77021 10.4227 10.0003 10.4227Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0003 10.4227C10.2304 10.4227 10.417 10.2362 10.417 10.0061C10.417 9.77596 10.2304 9.58941 10.0003 9.58941C9.77021 9.58941 9.58366 9.77596 9.58366 10.0061C9.58366 10.2362 9.77021 10.4227 10.0003 10.4227ZM8.75033 10.0061C8.75033 9.31572 9.30997 8.75608 10.0003 8.75608C10.6907 8.75608 11.2503 9.31572 11.2503 10.0061C11.2503 10.6964 10.6907 11.2561 10.0003 11.2561C9.30997 11.2561 8.75033 10.6964 8.75033 10.0061Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0003 3.33317C6.31843 3.33317 3.33366 6.31794 3.33366 9.99984C3.33366 13.6817 6.31843 16.6665 10.0003 16.6665C13.6822 16.6665 16.667 13.6817 16.667 9.99984C16.667 6.31794 13.6822 3.33317 10.0003 3.33317ZM1.66699 9.99984C1.66699 5.39746 5.39795 1.6665 10.0003 1.6665C14.6027 1.6665 18.3337 5.39746 18.3337 9.99984C18.3337 14.6022 14.6027 18.3332 10.0003 18.3332C5.39795 18.3332 1.66699 14.6022 1.66699 9.99984Z"
      fill="currentColor"
    />
    <circle cx="9.99967" cy="10.0002" r="4.16667" fill="currentColor" />
  </svg>
);

